import type {PreviewConfiguration} from 'schema/types';
import {PrizeWinners} from 'schemas/renderers/PrizeWinners';

export const prizePreviewConfig: PreviewConfiguration = {
  layout: {},
  partValueRenderers: {
    winners: PrizeWinners,
  },
};
